import { Button } from "@mui/material";

export const CustomButton = ({ title, classes, onClick, startIcon, color }) => {
  return (
    <Button
      fullWidth
      startIcon={startIcon}
      variant="contained"
      color={color}
      classes={classes}
      onClick={onClick}
    >
      {title}
    </Button>
  );
};
